import * as React from 'react';
import { Link } from '@inertiajs/react';
import type { NearbyBarrio } from '../../types/barrios-landing';

interface BarrioNearbyProps {
  nearby: NearbyBarrio[];
}

export function BarrioNearby({ nearby }: BarrioNearbyProps) {
  if (nearby.length === 0) return null;

  return (
    <section className="bs-nearby">
      <style>{`
        .bs-nearby {
          padding: 64px 24px;
          background: #fff;
        }
        .bs-nearby-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .bs-nearby h2 {
          font-size: 26px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .bs-nearby .section-sub {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 28px;
        }
        .bs-nearby-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 14px;
        }
        .bs-nearby-card {
          display: block;
          background: #fafaf7;
          border-radius: 10px;
          border: 1px solid #eee;
          padding: 18px 16px;
          text-decoration: none;
          transition: box-shadow 0.2s, border-color 0.2s;
        }
        .bs-nearby-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.06);
          border-color: #1EAA25;
          text-decoration: none;
        }
        .bs-nearby-name {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px;
        }
        .bs-nearby-city {
          font-size: 13px;
          color: #888;
          margin: 0 0 8px;
        }
        .bs-nearby-dist {
          font-size: 13px;
          color: #1EAA25;
          font-weight: 500;
        }
        .bs-nearby-dist i {
          margin-right: 4px;
          font-size: 12px;
        }
        @media (max-width: 768px) {
          .bs-nearby-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .bs-nearby h2 {
            font-size: 22px;
          }
        }
        @media (max-width: 480px) {
          .bs-nearby-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="bs-nearby-inner">
        <h2>Barrios cercanos</h2>
        <p className="section-sub">También entregamos en estos barrios</p>
        <div className="bs-nearby-grid">
          {nearby.map((b) => (
            <Link key={b.slug} href={`/barrios-privados/${b.slug}`} className="bs-nearby-card">
              <div className="bs-nearby-name">{b.name}</div>
              <div className="bs-nearby-city">{b.city}</div>
              <div className="bs-nearby-dist">
                <i className="fa fa-map-marker-alt" />
                A {b.distance_km} km
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
